module.exports = __webpack_public_path__ + "img/luottorahoitus.da3dba9.png";